import React from 'react';
import { useLassoTool } from '../../application/lassoToolStore';
import { useLassoManager } from '../hooks/useLassoManager';

export const LassoControlPanel = () => {
  const { isEnabled } = useLassoTool();
  const { confirmLasso, cancelLasso, clearSelection, selection } = useLassoManager();

  if (!isEnabled) return null;

  const shouldShowLasso = selection.length > 0;

  const mapToolBtn = 'flex flex-col items-center justify-center bg-white border rounded shadow hover:bg-gray-100 text-gray-800';
  const mapButtonStyle = 'py-0.5 px-1 rounded-sm bg-neutral-50 text-indigo-600 border-indigo-600 border-2 hover:text-indigo-800 hover:border-indigo-800 pointer-events-auto';

  return (
    <div className={'flex justify-between absolute w-[50%] pointer-events-none z-[2] bg-slate-500/70'}>
      <p className='m-2 col-start-1 self-center text-white font-extrabold  text-md drop-shadow-[0px_0px_2px_blue]'>
        {shouldShowLasso ? 'Confirm Selection To Search' : 'Draw Your Selection'}
      </p>

      <div className="self-center flex m-2 gap-2 z-[2] pointer-events-auto">
        <button className={mapButtonStyle} onClick={shouldShowLasso ? confirmLasso : cancelLasso}>
          {shouldShowLasso ? 'Confirm Lasso' : 'Cancel Lasso'}
        </button>
        {shouldShowLasso && (
          <button className={mapToolBtn} onClick={clearSelection}>
            Clear Selection
          </button>
        )}
      </div>
    </div>
  );
};
